/**
 * Layout modes for EntityPanelSelector
 */
export const LAYOUT_MODES = {
  TWO_COLUMNS: 'twoColumns',
  TWO_COLUMNS_WITH_FILTER: 'twoColumnsWithFilter',
  THREE_COLUMNS_WITH_FILTER: 'threeColumnsWithFilter',
};

